import { render, staticRenderFns } from "./StudentExaminationRoomAdd.vue?vue&type=template&id=d854b2ae&scoped=true&"
import script from "./StudentExaminationRoomAdd.vue?vue&type=script&lang=js&"
export * from "./StudentExaminationRoomAdd.vue?vue&type=script&lang=js&"
import style0 from "./StudentExaminationRoomAdd.vue?vue&type=style&index=0&id=d854b2ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d854b2ae",
  null
  
)

export default component.exports